import { render, staticRenderFns } from "./choicePeopleConsortiumInput.vue?vue&type=template&id=fccbd51c&scoped=true&"
import script from "./choicePeopleConsortiumInput.vue?vue&type=script&lang=js&"
export * from "./choicePeopleConsortiumInput.vue?vue&type=script&lang=js&"
import style0 from "./choicePeopleConsortiumInput.vue?vue&type=style&index=0&id=fccbd51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccbd51c",
  null
  
)

export default component.exports